import { navigationItems as NavigationItems } from './navigationItems';

export default NavigationItems;